export enum COMBOBOX {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=525426703
     */
    SELECTED_VALUES_LIST_LABEL = 'COMBOBOX.SELECTED_VALUES_LIST_LABEL',
}
